import { Type, type Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  EnumField,
  BooleanField,
  TextField,
  SlugField,
} from '@ayocore/platform/common/helpers/schema-types';
import accountingCurrencySchemaDefinition from './currency.schema';

import { name as moduleName } from '../module.json';
/**
 * Типы бухгалтерских документов.
 *
 * Определяет поведение документов (направление движения, необходимость строк,
 * возможность ручной нумерации и пр.).
 */
export const AccountingDocumentTypeSchema = Type.Object({
  ...SystemFields,

  code: SlugField({
    title: 'Код типа',
    description: 'Уникальный код типа документа (INVOICE, PURCHASE и т.д.).',
    unique: true,
  }),

  name: StringField({
    title: 'Название типа',
    minLength: 1,
    maxLength: 255,
    description: 'Название, отображаемое пользователю.',
  }),

  direction: EnumField(['inbound', 'outbound', 'internal'], {
    title: 'Направление движения',
    description: 'Определяет тип движения: приход, расход или внутренний документ.',
    default: 'internal',
  }),

  allow_manual_number: BooleanField({
    title: 'Ручная нумерация',
    default: true,
    description: 'Разрешает пользователям вводить номер вручную.',
  }),

  allow_negative_amount: BooleanField({
    title: 'Разрешить отрицательные суммы',
    default: false,
    description: 'Нужно для корректных возвратных документов.',
  }),

  is_active: BooleanField({
    title: 'Активен',
    default: true,
    description: 'Неактивные типы скрываются при создании документов.',
  }),

  description: TextField({
    title: 'Описание',
    nullable: true,
    description: 'Дополнительные накладные инструкции или бизнес-правила.',
  }),
});

export type AccountingDocumentType = Static<typeof AccountingDocumentTypeSchema>;

export default defineSchema({
  moduleName,
  tableName: 'document_types',
  schema: AccountingDocumentTypeSchema,
  additionalIndexes: [{ columns: ['code'], unique: true }, 'is_active'],
  dependencies: [accountingCurrencySchemaDefinition.tableName],
});
